import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat-alt",
  "use": "icon-chat-alt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"chatAltIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-chat-alt\"> <title id=\"icon-chat-alt_chatAltIconTitle\">Chat</title> <path d=\"M13,17 L7,21 L7,17 L3,17 L3,4 L21,4 L21,17 L13,17 Z\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol